if (!customElements.get('imm-home-slider')) {
  customElements.define('imm-home-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-imm-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-imm-slider-dot]'));
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.duration = Number(this.dataset.duration || 6000);
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.timer = null;
      this.touchStartX = 0;

      this.previousButton = this.querySelector('[data-imm-slider-previous]');
      this.nextButton = this.querySelector('[data-imm-slider-next]');
      this.currentCounter = this.querySelector('[data-imm-slider-current]');

      this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));

      this.addEventListener('touchstart', (event) => {
        this.touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });

      this.addEventListener('touchend', (event) => {
        const difference = event.changedTouches[0].clientX - this.touchStartX;
        if (Math.abs(difference) > 45) this.show(difference > 0 ? this.currentIndex - 1 : this.currentIndex + 1);
      }, { passive: true });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      this.start();
    }

    disconnectedCallback() { this.stop(); }

    show(index) {
      if (this.slides.length < 2) return;
      const nextIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === nextIndex);
        slide.classList.toggle('is-before', slideIndex < nextIndex);
        slide.setAttribute('aria-hidden', slideIndex === nextIndex ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === nextIndex);
        dot.setAttribute('aria-selected', dotIndex === nextIndex ? 'true' : 'false');
      });

      this.currentIndex = nextIndex;
      if (this.currentCounter) this.currentCounter.textContent = String(nextIndex + 1).padStart(2, '0');
      this.restart();
    }

    start() {
      if (!this.autoplayEnabled || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.duration);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() { if (this.autoplayEnabled) this.start(); }
  });
}

if (!window.immHomeSliderEditorBound) {
  window.immHomeSliderEditorBound = true;
  document.addEventListener('shopify:block:select', (event) => {
    const slider = event.target.closest('imm-home-slider');
    if (!slider || typeof slider.show !== 'function') return;
    const selected = slider.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    const index = slider.slides?.indexOf(selected);
    if (index >= 0) {
      slider.stop();
      slider.show(index);
    }
  });
}
